import type { CSSProperties, HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  radius?: number | string;
}

/** Shimmer placeholder — loading state of choice over spinners (brief §7.1). */
export function Skeleton({ width, height, circle, radius, className, style, ...rest }: SkeletonProps) {
  const s: CSSProperties = {
    width,
    height: height ?? (circle ? width : undefined),
    borderRadius: circle ? '50%' : radius,
    ...style,
  };
  return (
    <span
      className={cx('tc-skeleton', !height && !circle && 'tc-skeleton--text', circle && 'tc-skeleton--circle', className)}
      aria-hidden
      style={s}
      {...rest}
    />
  );
}

export interface SkeletonTextProps {
  lines?: number;
  /** Width of the last line (looks more natural shorter). */
  lastLineWidth?: string;
  className?: string;
}

/** A stack of shimmer lines. */
export function SkeletonText({ lines = 3, lastLineWidth = '70%', className }: SkeletonTextProps) {
  return (
    <span className={cx('tc-skeleton-lines', className)} aria-hidden>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? lastLineWidth : '100%'} />
      ))}
    </span>
  );
}
